// The single definition of "a signature value we are willing to store, gate
// on, or render".
//
// This lives in its own leaf module — no zod, no other shared imports — so
// that all three consumers can agree without importing each other:
//   - schemas.ts   builds the write-time zod validator from it
//   - progress.ts  gates submission completeness on it
//   - web-shared/safeSignatureSrc.ts guards the render (<img src>)
// progress.ts cannot import schemas.ts directly (schemas.ts already imports a
// type from progress.ts, and it would drag zod into every progress consumer),
// which is what this module exists to avoid.

// Signature data URLs must be base64-encoded data URLs to prevent stored SSRF
// attacks. Only PNG, JPEG, GIF, and WebP are accepted. The canvas produces
// data:image/png;base64, so this is not restrictive in practice — the goal is
// to reject any non-data: URL that could probe internal hosts or hit an
// external tracker when rendered as <img src>. Note SVG is excluded: it is an
// image type but a scriptable document.
export const SIGNATURE_DATA_URL_PATTERN =
  /^data:image\/(png|jpeg|gif|webp);base64,[A-Za-z0-9+/]+=*$/;

/** Is this value a signature image we would be willing to render? */
export function isSignatureDataUrl(value: unknown): value is string {
  return typeof value === 'string' && SIGNATURE_DATA_URL_PATTERN.test(value);
}
